import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const ImporteFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='IMPORTE' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='importeDetraccion'>
          {({ field }) => <Form.InputNumber {...field} id='number-importeDetraccion' isInvalid={iError && iTouched} disabled={fIsSubmitting} />}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFormGroup)
